module.exports = __webpack_public_path__ + "img/automation.4fb141b2.png";